module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_home"
  }, [_c('group', {
    attrs: {
      "gutter": "0.77em"
    }
  }, [_c('cell', {
    attrs: {
      "title": "个人信息",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toNext()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "24",
      "src": require("../../assets/img/a1.png")
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0.77em"
    }
  }, [_c('cell', {
    attrs: {
      "title": "关于我们",
      "link": "/about/",
      "is-link": ""
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "24",
      "src": require("../../assets/img/a2.png")
    },
    slot: "icon"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a90399f2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/user.vue
// module id = 345
// module chunks = 0